import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';

import moment, { Moment } from 'moment';
import { ReportOverallGradesComponent } from '../report-overall-grades/report-overall-grades.component';

/* import { FlowItemModel } from '../../models/FlowItemModel';
import { ReportViewDialogComponent } from '../../report-view-dialog/report-view-dialog.component'; */

@Component({
    selector: 'app-report-card-player',
    imports: [CommonModule, MaterialModule, ReportOverallGradesComponent, RouterModule ],
    templateUrl: './report-card-player.component.html',
    styleUrls: ['./report-card-player.component.css']
})
export class ReportCardPlayerComponent implements OnInit {

  borderColors: string[] = ['grayshading','redshading','yellowshading', 'yellowshading', 'greenshading','greenshading','greenshading','greenshading' ];

  @Input() Report: FlowItemModel;

  constructor(public _router: Router, public matDialog: MatDialog) { }

  ngOnInit() {
  }

    getTimeAgo(){
      moment.locale(localStorage.getItem("language")?.substring(0, 2) ?? 'en');
      return moment(this.Report.DateCreated).fromNow();
    }


  gotoPlayerDashboard(){
    this._router.navigateByUrl('/scouting/playertotalview');

  }

  

  gotoPlayerDetails(playerid: string){
    this._router.navigateByUrl('/scouting/playerdetails/' + playerid );

  }

/*   openViewReport(reportId:String) {
    const dialogConfig = new MatDialogConfig();
    this.matDialog.open(ReportViewDialogComponent, {
      data: { ReportId: reportId },
    });
  } */

  setClass(){
    return {    

      greenborder: this.Report.TotalQuality>3,
      yellowborder: this.Report.TotalQuality==2 || this.Report.TotalQuality==3,
      redborder: this.Report.TotalQuality==1,

    };


  }

  

}
